import {
  FigmaLogo,
  GitLogo,
  GithubLogo,
  LighthouseLogo,
  MongoLogo,
  NotionLogo,
  NpmLogo,
  PostmanLogo,
  VscLogo,
  YarnLogo,
} from '../assets/images/tools';

export const toolsList = [
  {
    id: '1',
    name: 'Figma',
    picture: FigmaLogo,
  },
  {
    id: '2',
    name: 'Git',
    picture: GitLogo,
  },
  {
    id: '3',
    name: 'GitHub',
    picture: GithubLogo,
  },
  {
    id: '4',
    name: 'Lighthouse',
    picture: LighthouseLogo,
  },
  {
    id: '5',
    name: 'MongoDB',
    picture: MongoLogo,
  },
  {
    id: '6',
    name: 'Notion',
    picture: NotionLogo,
  },
  {
    id: '7',
    name: 'npm',
    picture: NpmLogo,
  },
  {
    id: '8',
    name: 'Postman',
    picture: PostmanLogo,
  },
  {
    id: '9',
    name: 'VSCode',
    picture: VscLogo,
  },
  {
    id: '10',
    name: 'yarn',
    picture: YarnLogo,
  },
];
